import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useOrganizationWithOptions } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const buttonTextProps = {
   size: '1.5[a-d] 2[e-f]',
   color: 'inherit',
   weight: 'medium'
}

const NavHorizontal = ({ display, flex }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { organization, loading } = useOrganizationWithOptions({
      withGlobalNavLinksTargetMetadata: true
   })

   const buttonProps = {
      style: {
         color: theme.tmpMainMenuButtonTextColor,
         padding: '5px 10px',
         borderRadius: '4px',
         marginRight: '10px'
      },
      activeStyle: {
         color: theme.tmpMainMenuButtonActiveTextColor
      }
   }

   if (loading) {
      return null
   }

   // We don't want to show apps for legacy communities
   const legacyGlobalNavLinks = organization.globalNavLinks.filter(link => !link.app)

   return (
      <View>
         <View
            flex={flex}
            display={display}
            flexFlow="row"
            alignItems="flex-start">
            {/* TODO: Abstract this
            This will change when we decide how to handle Explore "Page" or "App"
            See PR #362 */}
            {organization.slug !== 'gns3' && (
               <NavLink to="/explore" {...buttonProps}>
                  <Text {...buttonTextProps}>
                     Explore
                  </Text>
               </NavLink>
            )}
            {legacyGlobalNavLinks.map((link) => {
               if (link.__typename === 'NavExternalLinkElement') {
                  return (
                     <a
                        key={link.id}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        {...buttonProps}>
                        <Text {...buttonTextProps}>
                           {link.name}
                        </Text>
                     </a>
                  )
               }

               return (
                  <NavLink key={link.id} to={link.url} {...buttonProps}>
                     <Text {...buttonTextProps}>
                        {link.name}
                     </Text>
                  </NavLink>
               )
            })}
         </View>
      </View>
   )
}

NavHorizontal.propTypes = {
   display: PropTypes.string.isRequired,
   flex: PropTypes.string.isRequired
}

export default NavHorizontal
